import { selector } from "recoil";
import { teamsState } from "./teamsState";

export const hasWorkspaceState = selector<boolean | undefined>({
  key: "hasWorkspaceState",
  get: ({get}) => {
    const teams = get(teamsState);
    return teams ? teams.findIndex(t => t.isWorkspace) > -1 : false;
  }
})